import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

export default function ProfileSectionCard({
  title,
  subtitle,
  children,
  action,
  sx = {},
  contentSx = {},
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        border: '1px solid rgba(44, 62, 80, 0.12)',
        borderRadius: { xs: 3, md: 4 },
        background: 'rgba(255, 255, 255, 0.72)',
        boxShadow: '0 20px 55px rgba(44, 62, 80, 0.08)',
        overflow: 'hidden',
        ...sx,
      }}
    >
      {(title || subtitle || action) && (
        <Box
          sx={{
            px: { xs: 2.5, sm: 4, md: 5 },
            pt: { xs: 2.5, sm: 3.5 },
            pb: { xs: 1.75, sm: 2.5 },
            position: 'relative',
            textAlign: 'center',
          }}
        >
          <Box sx={{ mx: 'auto', maxWidth: 860 }}>
            {title && (
              <Typography
                variant="h5"
                component="h2"
                sx={{
                  fontWeight: 800,
                  color: '#132838',
                  letterSpacing: '-0.015em',
                  fontSize: { xs: '1.45rem', sm: '1.7rem' },
                }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                variant="body1"
                sx={{
                  mt: 1,
                  color: '#40596a',
                  lineHeight: 1.7,
                  fontWeight: 500,
                  fontSize: { xs: '0.98rem', md: '1.05rem' },
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          {action && (
            <Box
              sx={{
                mt: { xs: 1.5, sm: 0 },
                position: { xs: 'static', sm: 'absolute' },
                top: { sm: 30 },
                right: { sm: 32, md: 40 },
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {action}
            </Box>
          )}
        </Box>
      )}
      <Box sx={{ px: { xs: 2.5, sm: 4, md: 5 }, pb: { xs: 2.5, sm: 4, md: 5 }, ...contentSx }}>
        {children}
      </Box>
    </Paper>
  );
}
